import React, {
  createContext, useContext, useState, useEffect,
} from 'react';
import PropTypes from 'prop-types';

const AccessibilityContext = createContext({
  handleContrastChange: () => {}, handleTextSizeChange: () => {},
});

export function AccessibilityContextProvider({ children }) {
  const [colorScheme, setColorScheme] = useState('light');
  const [textSize, setTextSize] = useState('normal');

  useEffect(() => {
    document.documentElement.className = `${colorScheme} ${textSize}`;
  }, [colorScheme, textSize]);

  function handleContrastChange() {
    switch (colorScheme) {
      case 'light':
        setColorScheme('dark');
        break;
      case 'dark':
        setColorScheme('light');
        break;
      default:
        setColorScheme('light');
    }
  }

  function handleTextSizeChange() {
    switch (textSize) {
      case 'normal':
        setTextSize('big');
        break;
      case 'big':
        setTextSize('normal');
        break;
      default:
        setTextSize('normal');
    }
  }

  const contextValue = { handleContrastChange, handleTextSizeChange };

  return (
    <AccessibilityContext.Provider value={contextValue}>
      {children}
    </AccessibilityContext.Provider>
  );
}

export function useAccessibilityContext() {
  return useContext(AccessibilityContext);
}

AccessibilityContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
